import React, { useState, useEffect } from "react"
import { useLocation, useParams } from "react-router-dom"
import { Button, Col, Form, Row, Table } from "react-bootstrap"
import Upload from "antd/es/upload/Upload"
import { Modal } from "antd"
import { useNavigate } from "react-router-dom"
import Navbar from "../../../../Components/Navbar/Navbar"
import trash from "./../../../../Assets/Images/trash.png"
import Select from "react-select"
import { Select as SearchBox } from "antd"
import "./../PurchaseOrders.css"
import {
  createSupplier,
  getAllSuppliers,
  searchSupplier,
} from "../../../../Helpers/apiCalls/suppliersApi"
import {
  numberFormat,
  toastStyle,
  getTodayDateISO,
  getUser,
  formatDate,
  antdesignSelectStyle,
  numberWithCommas,
} from "../../../../Helpers/Utils/Common"
import { createPurchaseOrder } from "../../../../Helpers/apiCalls/Purchases/purchaseOrderApi"
import { getAllForwarders } from "../../../../Helpers/apiCalls/forwardersApi"
import InputError from "../../../../Components/InputError/InputError"
import { validateAddPO } from "../../../../Helpers/Validation/Purchase/PurchaseOrderValidation"
import AddModal from "../../../../Components/Modals/AddModal"
import toast, { Toaster } from "react-hot-toast"
import "react-select-search/style.css"
import { getAllBranches } from "../../../../Helpers/apiCalls/Purchases/purchaseOrderApi"
import { validateSuppliers } from "../../../../Helpers/Validation/Manage/SuppliersValidation"
import { getAllEmployees } from "../../../../Helpers/apiCalls/employeesApi"
import ReactLoading from "react-loading"
import upload from "../../../../Assets/Images/upload.png"
import { getPurchaseRequest } from "../../../../Helpers/apiCalls/Purchases/purchaseRequestApi"
import {
  createItem,
  editItem,
  getItem,
  searchItem,
} from "../../../../Helpers/apiCalls/itemsApi"
import { Typeahead } from "react-bootstrap-typeahead"
import {
  getCategory,
  getSubcategory,
} from "../../../../Helpers/apiCalls/categoryApi"
import { getBrand } from "../../../../Helpers/apiCalls/brandsApi"
import { validateItems } from "../../../../Helpers/Validation/Manage/ItemsValidation"
import equal from "../../../../Assets/Images/equal.png"
import FileExceedModal from "../../../../Components/Modals/FileExceedModal"
import Compressor from "compressorjs"
import { createItemPrice } from "../../../../Helpers/apiCalls/Manage/ItemPrice"
import { getAllPriceLevels } from "../../../../Helpers/apiCalls/Manage/PriceLevels"
import Footer from "../../../../Components/Footer/Footer"

export default function AddPurchaseOrder({ add, generate }) {
  const { id } = useParams()
  const { Dragger } = Upload
  const navigate = useNavigate()
  const { state } = useLocation()
  const [isSubmitClicked, setIsSubmitClicked] = useState(false)
  const [isSaveClicked, setIsSaveClicked] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const [inactive, setInactive] = useState(true)
  const today = getTodayDateISO()
  const [fileList, setFileList] = useState([])
  const [formErrors, setFormErrors] = useState({})
  const [categories, setCategories] = useState([])
  const [filteredSubCategories, setFilteredSubCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [brand, setBrand] = useState([])
  const [showFileExceedModal, setShowFileExceedModal] = useState(false)
  const [priceLevelDetails, setPriceLevelDetails] = useState([[]])
  const [priceLevel, setPriceLevels] = useState([])
  const [filteredPriceLevel, setFilteredPriceLevels] = useState([])
  // ADD PRICE
  const [showAddItemPriceModal, setShowAddItemPriceModal] = useState(false)
  const handleShowAddItemPriceModal = () => setShowAddItemPriceModal(true)
  const handleCloseAddItemPriceModal = () => {
    setShowAddItemPriceModal(false)
  }
  const [newPO, setNewPO] = useState({
    supplier_id: "",
    purchase_date: today,
    delivery_date: today,
    vendor_id: "",
    branch_id: "1",
  })
  const [items, setItems] = useState([
    {
      item_id: "",
      qty: "0",
      current_qty: "0",
      unit: "",
      price: "0",
      discount_percentage: "0",
      discount_amount: "0",
      amount: "0",
    },
    {
      item_id: "",
      qty: "0",
      current_qty: "0",
      unit: "",
      price: "0",
      discount_percentage: "0",
      discount_amount: "0",
      amount: "0",
    },
    {
      item_id: "",
      qty: "0",
      current_qty: "0",
      unit: "",
      price: "0",
      discount_percentage: "0",
      discount_amount: "0",
      amount: "0",
    },
  ])
  const [itemsList, setItemsList] = useState([])
  const [itemsOptions, setItemsOptions] = useState([])
  const [filteredItemOptions, setFilteredItemOptions] = useState([])
  const [branchList, setBranchList] = useState([])
  const [employees, setEmployees] = useState([])
  const [isChanged, setIsChanged] = useState(false)
  const [fileSizeExceeded, setFileSizeExceeded] = useState(false)
  const [suppliersValue, setSuppliersValue] = useState({
    name: "supplier_id",
    label: "",
    value: "",
  })
  const [forwardersValue, setForwardersValue] = useState({
    name: "forwarder_id",
    label: "",
    value: "",
  })
  const [itemDetails, setItemDetails] = useState({
    name: "",
    type: "",
    detail: "",
    added_by: getUser(),
    added_on: formatDate(),
    category: [{ value: "" }],
    category_options: [{ value: "" }],
  })
  const [itemsUnits, setItemsUnits] = useState([
    {
      unit_from: "",
      value_from: "",
      unit_to: "",
      value_to: "",
      minimum: "",
      maximum: "",
      acceptable_variance: "",
    },
  ])

  const [branchValue, setBranchValue] = useState({})
  // ADD ITEM MODAL
  const [showAddItemModal, setShowAddItemModal] = useState(false)
  const handleShowAddItemModal = () => setShowAddItemModal(true)
  const handleCloseAddItemModal = () => setShowAddItemModal(false)
  // ADD Conversion
  const [showAddConversionModal, setShowAddConversionModal] = useState(false)
  const handleShowAddConversionModal = () => setShowAddConversionModal(true)
  const handleCloseAddConversionModal = () => setShowAddConversionModal(false)
  const [supplierDetails, setSupplierDetails] = useState({
    trade_name: "",
    trade_address: "",
    bir_name: "",
    bir_address: "",
    tin: "",
    terms: "",
    requirements: "",
    phone_no: "",
    email: "",
    contact_person: "",
    bank_primary: "",
    bank_alternate: "",
    payee: "",
  })
  const [showAddSupplierModal, setShowAddSupplierModal] = useState(false)
  const handleShowAddSupplierModal = () => setShowAddSupplierModal(true)
  const handleCloseAddSupplierModal = () => {
    setShowAddSupplierModal(false)
  }
  //ERROR HANDLING
  const [isError, setIsError] = useState({
    supplierName: false,
    purchaseDate: false,
    deliveryDate: false,
    requisitioner: false,
    deliveryAddress: false,
    branchId: false,
    price: false,
  })
  //ADD ITEM ERROR HANDLING
  const [isErrorItem, setIsErrorItem] = useState({
    name: false,
    inhouse_barcode: false,
    category: false,
    sales_type: false,
  })

  const handleSearchItem = (newValue) => {
    if (newValue.length > 2) {
      //if length of the input is greater than 3, it will call the search api
      handleFetchItems(newValue, setItemsOptions)
    }
  }

  // new api for searching items
  async function handleFetchItems(value, setItemsOptions) {
    setItemsOptions([])
    const response = await searchItem({ name: value })
    if (response.response) {
      var itemsList = response.response.data.map((data) => {
        var info = data
        info.label = data.name
        info.value = data.id

        return info
      })
      setItemsOptions(itemsList)
    } else {
      return toast.error(response.error?.data?.messages.message, {
        style: toastStyle(),
      })
    }
  }

  const handleRemove = (selectedFile) => {
    var newlist = fileList.filter((file) => {
      return selectedFile.uid !== file.uid
    })
    setFileList(newlist)
  }

  const handleBeforeUpload = (file) => {
    if (file.size > 2000000) {
      setShowFileExceedModal(true)
    } else {
      //COMPRESSING FILE
      new Compressor(file, {
        quality: 0.6,
        success: (compressedResult) => {
          setFileList([...fileList, compressedResult])
        },
      })
    }
    return false
  }

  // SELECT DROPDOWN CHANGE
  const handleSelectDropdownChange = (e, action, index) => {
    if (e.name === "category" || e.name === "subcategory") {
      // if category/subcategory ma save siya sud sa categories array
      var categories = [...itemDetails.category]
      // para if mo select siya ug another subcategory ma reset iya child
      if (
        categories[index]?.value ? categories[index]?.value !== e.value : false
      ) {
        categories.splice(index)
      }
      // para ma set ang value sa selected category
      categories[index] = { value: e.value, label: e.label }
      fetchSubcategories(e.id, categories, "add", index)
      setItemDetails({
        ...itemDetails,
        ["category"]: categories,
        // [e.name]: e.value,
        [`${e.name}_id`]: e.id,
        // [e.selected_value_name]: {
        //   label: e.label,
        //   value: e.value,
        // },
      })
    } else {
      setItemDetails({
        ...itemDetails,
        [e.name]: e.value,
        [`${e.name}_id`]: e.id,
        // [e.selected_value_name]: {
        //   label: e.label,
        //   value: e.value,
        // },
      })
    }
  }

  // Function to remove an input field
  const handleRemoveSubcategory = (index, type) => {
    var categories = []
    categories = itemDetails.category

    const newInputs = [...categories]
    newInputs.splice(index) // Remove the input at the specified index
    setItemDetails({
      // Update the state with the new array
      ...itemDetails,
      ["category"]: newInputs,
    })
  }

  function handleAddItem() {
    // window.open("/items", "_blank");
    handleShowAddItemModal()
    fetchCategories()
    fetchBrands()
  }

  function handleAddSupplierClick() {
    window.open("/suppliers", "_blank")
  }

  // FUNCTION FETCH ITEM CATEGORIES
  async function fetchCategories() {
    const response = await getCategory({})
    if (response.data) {
      //categories
      var categories = response.data.data.map((category) => {
        var info = {}
        info.name = "category"
        info.value = category.name
        info.label = category.name
        info.id = category.id
        info.selected_value_name = "selected_category"
        return info
      })
      setCategories(categories)
    }
  }

  async function fetchSubcategories(id, categories, type, index) {
    setSubCategories([])
    const response = await getSubcategory(id)
    if (response.data) {
      //subcategories
      var subcategories = response.data.data.map((category) => {
        var info = {}
        info.name = "subcategory"
        info.value = category.name
        info.label = category.name
        info.id = category.id
        info.category_id = category.category_id
        info.selected_value_name = "selected_subcategory"
        return info
      })
      setSubCategories(subcategories)

      // to set categories and options
      const options = [...itemDetails.category_options] // Create a copy of the options array
      options[index + 1] = subcategories // Update the value at the specified index

      setItemDetails({
        ...itemDetails,
        ["category"]: [...categories, ""],
        ["category_options"]: [...options],
      })
    } else {
      //display error toast message if status code is 400
      response.error?.response?.data?.messages.map((data) => {
        // return toast.error(data);
        return toast.error(data, {
          style: toastStyle(),
        })
      })
    }
  }

  // FUNCTION FETCH ITEM BRAND
  async function fetchBrands() {
    const response = await getBrand({})
    if (response.data) {
      var brands = response.data.data.map((brand) => {
        var info = {}
        info.name = "brand"
        info.value = brand.name
        info.label = brand.name
        info.id = brand.id
        info.selected_value_name = "selected_brand"
        return info
      })
      setBrand(brands)
    }
  }

  async function fetchItems() {
    const response = await searchItem({})
    setFilteredItemOptions([])

    if (response.response) {
      setItemsList(response.response.data)

      let result = response.response.data.map((a) => {
        return {
          label: a.name,
          value: a.id,
          item_id: a.id,
        }
      })
      setItemsOptions(result)
      setFilteredItemOptions(result)
    }
  }

  async function fetchBranches() {
    const response = await getAllBranches()

    if (response.data) {
      var tempBranches = []
      response.data.data.map((branch) => {
        var info = {}

        if (branch.is_franchise === 3 || branch.is_franchise === "3") {
          info.name = "branch_id"
          info.label = branch.name
          info.value = branch.id
          info.address = branch.address
          tempBranches.push(info)
        }
      })
      setBranchList(tempBranches)
      setBranchValue(tempBranches[0])
      setNewPO((prev) => {
        return { ...prev, delivery_address: tempBranches[0].address }
      })
    }
  }

  async function fetchEmployees() {
    setEmployees([])
    const response = await getAllEmployees()

    if (response.data) {
      let result = response.data.data.map((data) => {
        return {
          label: data.first_name + " " + data.last_name,
          value: data.id,
        }
      })
      setEmployees(result)
    }
  }

  function handleRemoveItem(index) {
    setIsChanged(true)

    const newItemList = [...items]
    newItemList.splice(index, 1)
    setItems(newItemList)

    const filteredOptions = itemsOptions.filter((option) => {
      return !newItemList.find((item) => item.item_id === option.item_id)
    })
    setFilteredItemOptions(filteredOptions)

    newPO.grand_total = newItemList
      .map((item) => item.amount)
      .reduce((a, b) => a + b, 0)

    setTimeout(() => setIsChanged(false), 1)
  }

  function AddItem() {
    const newItem = {
      item: "",
      qty: 1,
      unit: "",
      price: 0,
      amount: 0,
      discount_amount: 0,
      discount_percentage: 0,
      subtotal: 0,
    }
    setItems((prevItems) => [...prevItems, newItem])
  }

  // ORDER ITEMS CHANGE
  function handleItemChange(e, id, search) {
    setIsChanged(true)
    if (search) {
      var item_name = itemsOptions.filter((data) => {
        return data.value === e
      })

      const list = [...items]
      list[id].item_id = e
      list[id].item_id_value = {
        label: item_name[0].label,
        value: item_name[0].value,
      }

      if (
        parseInt(item_name[0]?.item_units[0]?.current_qty) <
        parseInt(item_name[0]?.item_units[0]?.max)
      ) {
        list[id]["qty"] =
          item_name[0]?.item_units[0]?.max -
          item_name[0]?.item_units[0]?.current_qty
      } else if (
        parseInt(item_name[0]?.item_units[0]?.current_qty) >=
        parseInt(item_name[0]?.item_units[0]?.max)
      ) {
        list[id]["qty"] = parseInt(item_name[0]?.item_units[0]?.max)
      } else {
        list[id]["qty"] = 1
      }

      list[id]["item_units"] = item_name[0]?.item_units
      list[id]["qty"] = numberWithCommas(item_name[0]?.item_units[0]?.order_qty)
      list[id]["unit"] = item_name[0]?.item_units[0]?.unit_to
      list[id]["current_qty"] = item_name[0]?.item_units[0]?.current_qty
      list[id]["price"] =
        item_name[0]?.item_units[0]?.previous_item_price || "0"
      list[id]["amount"] =
        parseFloat(list[id]["qty"] ? list[id]["qty"] : 0) *
        parseFloat(list[id]["price"] ? list[id]["price"] : 0)
      list[id]["subtotal"] =
        parseFloat(list[id]["qty"] ? list[id]["qty"] : 0) *
        parseFloat(list[id]["price"] ? list[id]["price"] : 0)
      // itemsOptions?.map((data) => {
      //   data.item_units?.map((info) => {
      //     if (e === info.value) {
      //       if(add) {
      //         if (parseInt(item_name[0]?.item_units.current_qty) < parseInt(item_name[0]?.item_units.max)) {
      //           list[id]["qty"] = item_name[0]?.item_units.max - item_name[0]?.item_units.current_qty;
      //         } else if (parseInt(item_name[0]?.item_units.current_qty) >= parseInt(item_name[0]?.item_units.max)) {
      //           list[id]["qty"] = parseInt(item_name[0]?.item_units.max);
      //         } else {
      //           list[id]["qty"] = 1;
      //         }

      //         list[id]["unit"] = item_name[0]?.item_units.unit_to;
      //         list[id]["current_qty"] = item_name[0]?.item_units.current_qty;
      //         list[id]["price"] = item_name[0]?.item_units.previous_item_price || "0";
      //         list[id]["amount"] =
      //           parseFloat(list[id]["qty"] ? list[id]["qty"] : 0) *
      //           parseFloat(list[id]["price"] ? list[id]["price"] : 0);
      //         list[id]["subtotal"] =
      //           parseFloat(list[id]["qty"] ? list[id]["qty"] : 0) *
      //           parseFloat(list[id]["price"] ? list[id]["price"] : 0);
      //       } else {
      //         list[id]["unit"] = item_name[0]?.item_units.unit_to;
      //       }
      //     }
      //   });
      // });

      const filteredOptions = itemsOptions.filter((option) => {
        return !list.find((item) => item.item_id === option.item_id)
      })
      setFilteredItemOptions(filteredOptions)
      setItems(list)
    } else {
      const { name, value } = e.target
      const list = [...items]

      if (
        name === "qty" ||
        name === "price" ||
        name === "discount_percentage"
      ) {
        items.map((item, index) => {
          if (index === id) {
            item[name] = value
            var tempTotal = parseFloat(item.qty) * parseFloat(item.price)
            var totalDiscount =
              tempTotal * (parseFloat(item.discount_percentage) / 100)
            item.subtotal = parseFloat(tempTotal)
            item.amount = tempTotal - totalDiscount
            item.discount_amount = totalDiscount
          }
        })
        newPO.grand_total = items
          .map((item) => item.amount)
          .reduce((a, b) => a + b, 0)
      } else {
        items.map((item, index) => {
          if (index === id) {
            item[name] = value
          }
        })

        newPO.grand_total = items
          .map((item) => item.amount)
          .reduce((a, b) => a + b, 0)
      }
      setItems(list)

      setTimeout(() => setIsChanged(false), 1)
    }
  }

  // ITEM CONVERSION CHANGE
  function handleConversionChange(e, id) {
    const { name, value } = e.target
    var newItemsUnits = itemsUnits
    if (name === "unit_from") {
      var newBreakdownUnit = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.unit_from = value
        }
        return item
      })
      setItemsUnits(newBreakdownUnit)
    } else if (name === "value_from") {
      var newBreakdownValue = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.value_from = value
        }
        return item
      })
      setItemsUnits(newBreakdownValue)
    } else if (name === "unit_to") {
      var newInventoryUnit = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.unit_to = value
        }
        return item
      })
      setItemsUnits(newInventoryUnit)
    } else if (name === "value_to") {
      var newInventoryValue = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.value_to = value
        }
        return item
      })
      setItemsUnits(newInventoryValue)
    } else if (name === "minimum") {
      var newMinimum = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.minimum = value
        }
        return item
      })
      setItemsUnits(newMinimum)
    } else if (name === "maximum") {
      var newMaximum = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.maximum = value
        }
        return item
      })
      setItemsUnits(newMaximum)
    } else if (name === "acceptable_variance") {
      var newAcceptableVatriance = newItemsUnits.map((item, index) => {
        if (index === id) {
          item.acceptable_variance = value
        }
        return item
      })
      setItemsUnits(newAcceptableVatriance)
    }
  }

  async function handleAddSupplier() {
    if (validateSuppliers(supplierDetails, setIsError)) {
      const response = await createSupplier(supplierDetails)
      if (response.response) {
        toast.success(response.response.response, {
          style: toastStyle(),
        })
        handleCloseAddSupplierModal()
      } else {
        toast.error("Error Creating New Supplier", {
          style: toastStyle(),
        })
      }
    }
  }

  // Create item onchange
  const handleAddChange = (e) => {
    const { name, value } = e.target

    setItemDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleTypeaheadChange = (e, labelKey) => {
    if (e[0] !== undefined) {
      if (e[0].customOption) {
        setItemDetails((prevState) => ({
          ...prevState,
          [labelKey]: e[0].value,
          [`${labelKey}_id`]: "",
          [`selected_${labelKey}`]: [e[0]],
        }))
      } else {
        setItemDetails((prevState) => ({
          ...prevState,
          [e[0].name]: e[0].value,
          [`${labelKey}_id`]: e[0].id,
          [`selected_${labelKey}`]: [e[0]],
        }))
      }
    } else if (e === undefined || e === null || e.length === 0) {
      setItemDetails((prevState) => ({
        ...prevState,
        [labelKey]: "",
        [`${labelKey}_id`]: "",
        [`selected_${labelKey}`]: [],
      }))
    }
  }

  async function fetchItem(id) {
    const response = await getItem(id)
    if (response.data) {
      var data = response.data[0]
      data.item_name = data.name
      data.item_id = data.id

      // to set the first array to the item units of the selected item
      const newList = [...priceLevelDetails]
      var units = data.item_units.map((data) => {
        var info = data
        info.original_cost_price = data.cost_price
        return info
      })
      newList[priceLevelDetails.length - 1] = units
      setPriceLevelDetails(newList)
      handleShowAddItemPriceModal()
      handleCloseAddConversionModal()

      if (data.item_units === false) {
        response.data.map((data) => (data.item_units = data.item_units || []))
        setItemsUnits([])
        setItemDetails(data)
      } else {
        setItemsUnits(data.item_units)
        setItemDetails(data)
      }
    } else {
      setItemDetails({})
    }
  }

  async function fetchBranches() {
    const response = await getAllBranches()

    if (response.data) {
      var tempBranches = []
      response.data.data.map((branch) => {
        var info = {}

        if (branch.is_franchise === 3 || branch.is_franchise === "3") {
          info.name = "branch_id"
          info.label = branch.name
          info.value = branch.id
          info.address = branch.address
          tempBranches.push(info)
        }
      })
      setBranchList(tempBranches)
    }
  }

  // FUNCTION TO SAVE ITEM
  async function handleSaveItem() {
    // var hasUnits = itemsUnits.length > 0 ? true : false;
    if (validateItems(itemDetails, setIsErrorItem)) {
      setIsClicked(true)
      const response = await createItem(itemDetails, itemsUnits)
      if (response.response) {
        setItemDetails((prevState) => ({
          ...prevState,
          id: response.response.item_id,
        }))
        toast.success(response.response.message, {
          style: toastStyle(),
        })
        handleCloseAddItemModal()
        handleShowAddConversionModal()
        setIsClicked(false)
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
      }
      setIsClicked(false)
    } else {
      toast.error("Please fill in all fields!", { style: toastStyle() })
    }
  }
  // FUNCTION TO SAVE ITEM CONVERSION
  async function handleAddConversion() {
    setIsClicked(true)

    const response = await editItem(itemDetails, itemsUnits)
    if (response.response) {
      var details = { ...itemDetails }
      details.item_id = response.response.item_id
      details.item_unit_id = response.response.item_unit_id
      details.unit = response.response.unit
      details.unit_from = itemsUnits.unit_from
      details.unit_to = itemsUnits.unit_to
      setItemDetails(details)
      fetchItem(response.response.item_id)
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
    }
    setIsClicked(false)
  }

  function renderTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th>Item</th>
            <th>Quantity</th>
            <th>Current</th>
            <th>Unit</th>
            <th className="numeric-input">Unit Price (₱)</th>
            <th>Discount (%)</th>
            <th>Amount</th>
            <th>Remarks</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            console.log("1", item)
            return (
              <tr>
                <td>
                  {state && item.isReadOnly ? (
                    <Form.Control
                      type="text"
                      name="item_id"
                      value={item.item_name}
                      disabled
                    />
                  ) : (
                    <>
                      <Form.Control
                        type="text"
                        name="description"
                        className="nc-modal-custom-input mb-1 w-full"
                        value={item.description}
                        onChange={(e) => handleItemChange(e, index, false)}
                        placeholder="Description"
                        // disabled
                      />
                      {formErrors[index] && formErrors[index].description && (
                        <div className="validity-error callout bottom">
                          {formErrors[index].description}
                        </div>
                      )}
                      <SearchBox
                        showSearch
                        value={item.item_id_value}
                        placeholder={"Search Item..."}
                        className="react-select-container w-full"
                        dropdownClassName="z-large antdesign-custom-dropdown"
                        style={antdesignSelectStyle}
                        defaultActiveFirstOption={false}
                        suffixIcon={null}
                        filterOption={false}
                        onSearch={handleSearchItem}
                        onChange={(e) => handleItemChange(e, index, true)}
                        notFoundContent={null}
                        options={(itemsOptions || []).map((d) => ({
                          value: d.value,
                          label: d.label,
                        }))}
                      />
                      {/* <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={filteredItemOptions}
                        value={item.item_id_value}
                        name="item_id"
                        placeholder="Choose item"
                        onChange={(e) => handleItemChange(e, index, true)}
                        search={true}
                      /> */}
                    </>
                  )}
                </td>
                <td>
                  <Form.Control
                    type="text"
                    name="qty"
                    value={item.qty}
                    onChange={(e) => handleItemChange(e, index, false)}
                  />
                  {formErrors[index] && formErrors[index].qty && (
                    <div className="validity-error callout bottom">
                      {formErrors[index].qty}
                    </div>
                  )}
                </td>
                <td>
                  <Form.Control
                    type="text"
                    name="current"
                    value={numberWithCommas(item.current_qty)}
                    // onChange={(e) => handleItemChange(e, index, false)}
                    disabled
                  />
                </td>
                <td>
                  {state && item.isReadOnly ? (
                    <Form.Control
                      type="text"
                      name="unit_to_name"
                      className="nc-modal-custom-input"
                      value={item.unit_to_name}
                      disabled
                    />
                  ) : (
                    <>
                      {item.item_id === "" || item.item_id === undefined ? (
                        <Form.Control
                          type="text"
                          name="unit"
                          className="hide-spinner"
                          value={item.unit}
                          onChange={(e) => handleItemChange(e, index, false)}
                        />
                      ) : (
                        <Form.Select
                          name="unit"
                          id={item.id}
                          className="hide-spinner"
                          value={item.unit}
                          onChange={(e) => handleItemChange(e, index, false)}
                        >
                          <option value="">Select</option>
                          {item?.item_units?.map((info) => {
                            return (
                              <option value={info.unit_to}>
                                {info.unit_to}
                              </option>
                            )
                          })}
                          {/* {itemsOptions
                            ?.filter((info) => info.value == item.item_id)
                            .map((data) => {
                              return data.item_units.map((info) => {
                                return (
                                  <option value={info.unit_to}>
                                    {info.unit_to}
                                  </option>
                                );
                              });
                            })} */}
                        </Form.Select>
                      )}
                    </>
                  )}
                  {formErrors[index] && formErrors[index].unit && (
                    <div className="validity-error callout bottom">
                      {formErrors[index].unit}
                    </div>
                  )}
                </td>
                <td className="row align-contents d-flex mt-3 flex-column text-center">
                  {/* <Col className="align-middle">PHP</Col> */}
                  <Col>
                    <Form.Control
                      type="number"
                      name="price"
                      className="hide-spinner"
                      value={item.price}
                      onChange={(e) => handleItemChange(e, index, false)}
                    />
                    {formErrors[index] && formErrors[index].price && (
                      <div className="validity-error callout bottom">
                        {formErrors[index].price}
                      </div>
                    )}
                  </Col>
                </td>
                <td>
                  <Form.Control
                    className="mb-1"
                    type="number"
                    name="discount_percentage"
                    defaultValue={item.discount_percentage}
                    onChange={(e) => handleItemChange(e, index, false)}
                  />
                  <Form.Control
                    type="number"
                    name="discount_amount"
                    value={item.discount_amount}
                    onChange={(e) => handleItemChange(e, index, false)}
                    disabled
                  />
                </td>
                {/* <td>
                  <Form.Control type="number" name="discount_amount" value={item.discount_amount} onChange={(e) => handleItemChange(e,index,false)} disabled/>
                </td> */}
                <td>{numberFormat(item.amount)}</td>
                <td>
                  <Form.Control
                    type="text"
                    name="remarks"
                    value={item.remarks}
                    onChange={(e) => handleItemChange(e, index, false)}
                  />
                </td>
                <td>
                  <img
                    src={trash}
                    onClick={() => handleRemoveItem(index)}
                    className="cursor-pointer"
                    alt=""
                  />
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  // ADD CONVERSION TABLE
  function renderTableConversion() {
    return (
      <Table>
        <thead>
          <tr>
            <th>
              VALUE 1 - Warehouse Unit<span className="required">*</span>
            </th>
            <th> </th>
            <th>
              VALUE 2 - Store Unit<span className="required">*</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {itemsUnits.map((item, index) => {
            return (
              <tr>
                <td className="row align-contents">
                  <Col>
                    <Form.Control
                      type="number"
                      name="value_to"
                      className="nc-modal-custom-input"
                      onChange={(e) => handleConversionChange(e, index)}
                      // disabled
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      name="unit_to"
                      className="nc-modal-custom-input"
                      onChange={(e) => handleConversionChange(e, index)}
                      // disabled
                    />
                  </Col>
                </td>

                <td>
                  <img src={equal} className="cursor-pointer" alt="equal to" />
                </td>

                <td className="row align-contents">
                  <Col>
                    <Form.Control
                      type="number"
                      name="value_from"
                      className="nc-modal-custom-input hide-spinner numeric-input"
                      onChange={(e) => handleConversionChange(e, index)}
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      type="text"
                      name="unit_from"
                      className="nc-modal-custom-input"
                      onChange={(e) => handleConversionChange(e, index)}
                    />
                  </Col>
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  /** Suppliers **/
  const [suppliers, setSuppliers] = useState([])

  const handleSearchSupplier = (newValue) => {
    if (newValue.length > 2) {
      //if length of the input is greater than 3, it will call the search api
      fetchSuppliers(newValue, setSuppliers)
    }
  }

  // new api for searching items
  async function fetchSuppliers(value, setSuppliers) {
    setSuppliers([])
    const response = await searchSupplier({ name: value })
    if (response.response) {
      var suppliers = response.response.data.map((data) => {
        var info = data
        info.label = data.trade_name
        info.value = data.id
        info.label = data.trade_name
        info.contact_person = data.contact_person
        info.phone_no = data.phone_no

        return info
      })
      setSuppliers(suppliers)
    } else {
      response.error?.data?.messages.map((data) => {
        return toast.error(data, {
          style: toastStyle(),
        })
      })
    }
  }

  /** Forwarders **/
  const [forwarders, setForwarders] = useState([])

  async function fetchForwarders() {
    setForwarders([])

    const response = await getAllForwarders()

    if (response.data) {
      response.data.data.map((forwarder) => {
        var info = {}

        info.name = "forwarder_id"
        info.label = forwarder.name
        info.value = forwarder.id
        info.contact_person = forwarder.contact_person
        info.phone_no = forwarder.phone_no

        setForwarders((prev) => [...prev, info])
      })
    }
  }

  function handleSelectChange(e, type) {
    const newList = { ...newPO }
    newList[e.name] = e.value
    setNewPO(newList)

    if (type === "requisitioner") {
      setNewPO((prev) => {
        return { ...prev, requisitioner: { label: e.label, value: e.value } }
      })
    } else if (type === "supplier_id") {
      var supplier_name = suppliers.filter((data) => {
        return data.value === e
      })
      setNewPO((prev) => {
        return {
          ...prev,
          supplier_id: e,
          contact_name: supplier_name[0].contact_person,
          contact_no: supplier_name[0].phone_no,
          supplier_id_value: {
            label: supplier_name[0].label,
            value: supplier_name[0].value,
          },
        }
      })
    } else if (e.name === "branch_id") {
      setBranchValue({ name: e.name, label: e.label, value: e.value })
      var address = branchList.filter((data) => data.value === e.value)[0]
        .address
      setNewPO((prev) => {
        return {
          ...prev,
          delivery_address: address !== null ? address : "",
          branch_id: e.value,
          branch_id_value: { name: e.name, label: e.label, value: e.value },
        }
      })
    } else {
      setForwardersValue({
        name: e.name,
        label: e.label,
        value: e.value,
      })
      setNewPO((prev) => ({
        ...prev,
        contact_person: e.phone_no,
      }))
    }
  }

  function handlePOChange(e) {
    const { name, value } = e.target

    if (name === "branch_id") {
      var address = branchList.filter((data) => data.id === value)[0].address
      // setNewPO({
      //   ...newPO,
      //   delivery_address: address !== null ? address : "",
      //   branch_id: value,
      // });
      setNewPO((prev) => {
        return {
          ...prev,
          delivery_address: address !== null ? address : "",
          branch_id: value,
        }
      })
    } else {
      // setNewPO({ ...newPO, [name]: value });
      setNewPO((prev) => {
        return { ...prev, [name]: value }
      })
    }

    if (name === "service_fee" || name === "discount") {
      setIsChanged(!isChanged)
    }
  }
  async function savePO() {
    newPO.is_save = 1
    newPO.status = "pending"
    var hasItems = items.length > 0 ? true : false
    var hasItemContent = hasItems
      ? items[0].qty !== "" &&
        items[0].unit !== "" &&
        items[0].qty !== "0" &&
        items[0].unit !== 0
      : false
    isError["POItems"] = !(hasItems && hasItemContent)
    if (isSaveClicked || isSubmitClicked) {
      return
    }
    // VALIDATE ITEMS
    const errors = {}
    // const finalItems = []
    items.map((item, itemIndex) => {
      if (
        (!item.hasOwnProperty("description") ||
          (item.hasOwnProperty("description") && !item.description)) &&
        item.item_id === ""
      ) {
        errors[itemIndex] = {
          ...errors[itemIndex],
          description: "Item or description is required",
        }
      }

      if (!item.qty.toString() || parseInt(item.qty) <= 0) {
        errors[itemIndex] = {
          ...errors[itemIndex],
          qty: "Qty is required and make sure it is greater than 0",
        }
      }

      if (!item.unit.toString() || item.unit === "") {
        errors[itemIndex] = {
          ...errors[itemIndex],
          unit: "Unit is required",
        }
      }
      if (!item.price || parseInt(item.price) <= 0) {
        errors[itemIndex] = {
          ...errors[itemIndex],
          price: "Price is required and make sure it is greater than 0",
        }
      }
    })

    setFormErrors(errors)

    // END OF ITEM VALIDATION
    if (
      validateAddPO(newPO, items, setIsError) &&
      Object.keys(errors).length === 0
    ) {
      setIsSaveClicked(true)
      newPO.attachments = fileList
      newPO.branch_id = branchValue.value
      newPO.purchase_request_id = id || null
      const response = await createPurchaseOrder(newPO, items)
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        setTimeout(() => {
          navigate("/purchaseorders")
        }, 1000)
      } else {
        setIsSaveClicked(false)
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
      }
      setIsSaveClicked(false)
    } else {
      toast.error("Please fill in all fields", {
        style: toastStyle(),
      })
    }
  }

  async function submitPO() {
    newPO.is_save = 0
    newPO.status = "for approval"
    var hasItems = items.length > 0 ? true : false
    var hasItemContent = hasItems
      ? items[0].qty !== "" &&
        items[0].unit !== "" &&
        items[0].qty !== "0" &&
        items[0].unit !== 0
      : false
    isError["POItems"] = !(hasItems && hasItemContent)
    if (isSaveClicked || isSubmitClicked) {
      return
    }
    // VALIDATE ITEMS
    const errors = {}
    // const finalItems = []
    items.map((item, itemIndex) => {
      if (
        (!item.hasOwnProperty("description") ||
          (item.hasOwnProperty("description") && !item.description)) &&
        item.item_id === ""
      ) {
        errors[itemIndex] = {
          ...errors[itemIndex],
          description: "Item or description is required",
        }
      }

      if (!item.qty.toString() || parseInt(item.qty) <= 0) {
        errors[itemIndex] = {
          ...errors[itemIndex],
          qty: "Qty is required and make sure it is greater than 0",
        }
      }

      if (!item.unit.toString() || item.unit === "") {
        errors[itemIndex] = {
          ...errors[itemIndex],
          unit: "Unit is required",
        }
      }

      if (!item.price || parseInt(item.price) <= 0) {
        errors[itemIndex] = {
          ...errors[itemIndex],
          price: "Price is required and make sure it is greater than 0",
        }
      }
    })

    setFormErrors(errors)

    // END OF ITEM VALIDATION

    if (
      validateAddPO(newPO, items, setIsError) &&
      Object.keys(errors).length === 0
    ) {
      setIsSubmitClicked(true)
      newPO.attachments = fileList
      newPO.branch_id = branchValue.value
      newPO.purchase_request_id = id
      const response = await createPurchaseOrder(newPO, items)
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        setTimeout(
          () =>
            navigate("/purchaseorders/review/0/" + response.data.purchase_id),
          1000
        )
      } else {
        setIsSubmitClicked(false)
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
      }
      setIsSubmitClicked(false)
    } else {
      toast.error("Please fill in all fields", {
        style: toastStyle(),
      })
    }
  }

  async function fetchPurchaseRequest() {
    setNewPO([])
    setIsChanged(true)
    const response = await getPurchaseRequest({ id: id })
    if (response.data) {
      var data = response.data.data.map((data) => {
        var info = data
        info.purchase_date = today
        info.delivery_date = data.required_date
        info.supplier_id = ""
        info.vendor_id = ""
        info.forwarder_id = ""
        info.service_fee = 0
        info.discount = 0
        info.branch = data.branch
        info.branch_id_value = {
          label: data.branch,
          value: data.branch_id,
        }
        info.requisitioner = {
          label: data.requested_by_name,
          value: data.requested_by,
        }
        return info
      })
      // setNewPO({...newPO, ...data[0]});
      setNewPO((prev) => {
        return { ...prev, ...data[0] }
      })
      setBranchValue(data[0].branch_id_value)
      var itemsdata = data[0].purchase_request_items.map((data) => {
        var info = data
        info.qty = data.quantity ? data.quantity : 0
        info.price = data.selling_price ? data.selling_price : 0
        info.amount = info.qty * info.price
        info.subtotal = info.qty * info.price
        info.discount_amount = 0
        info.discount_percentage = 0
        info.unit = data.uom
        info.item_id = ""
        // info.item_id_value = {
        //     label: data.item_name,
        //     value: data.item_id,
        // }
        return info
      })
      setItems(itemsdata)
    }
    setTimeout(() => setIsChanged(false), 1)
  }

  const [previewFile, setPreviewFile] = useState(null)
  const [preview, setPreview] = useState(false)

  const handlePreview = async (file) => {
    if (Object.prototype.toString.call(file) === "[object File]") {
      const blob = new Blob([file], { type: file.type })
      file.preview = URL.createObjectURL(blob)
    }
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }
    setPreviewFile(file.preview)
    setPreview(true)
  }

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })

  useEffect(() => {
    fetchForwarders()
    // fetchSuppliers();
    fetchBranches()
    fetchEmployees()
    fetchPriceLevel()
    if (generate) {
      fetchPurchaseRequest()
    }
  }, [])

  // ADD PRICE LEVEL HANDLER
  function handleAddPriceLevel() {
    var newList = []
    var units = itemDetails.item_units.map((data) => {
      var info = data
      info.original_cost_price = data.cost_price
      return info
    })
    newList = units

    setPriceLevelDetails((oldItems) => [...oldItems, newList])
  }

  // PRICE LEVEL REMOVAL HANDLER
  function handleRemovePriceLevel(id) {
    const rowId = id
    const newItemList = [...priceLevelDetails]
    newItemList.splice(rowId, 1)
    setPriceLevelDetails(newItemList)

    // to filter price level and remove the selected ones in the option
    const flattenedNewList = newItemList.flat() // Flatten the nested arrays
    const filteredOptions = priceLevel.filter((option) => {
      // Check if any object in flattenedNewList has the same price_level_id
      return !flattenedNewList.some(
        (item) => item.price_level_id === option.value
      )
    })

    setFilteredPriceLevels(filteredOptions)
  }

  // updated price level details change
  const handlePriceLevelChange = (e, type, level_index, unit_index) => {
    if (type === "price_level") {
      const { name, value, label } = e
      const newList = [...priceLevelDetails]

      const updatedList = newList.map((subArray, index) => {
        if (index === level_index) {
          // If the current subArray index matches the level_index, update its elements
          return subArray.map((item) => ({
            ...item,
            price_level_id: value,
            price_level_id_value: {
              label: label,
              value: value,
            },
          }))
        }
        return subArray // If not the targeted index, return the subArray unchanged
      })
      // to set select dropdown value
      updatedList[level_index]["price_level_id_value"] = {
        label: label,
        value: value,
      }
      setPriceLevelDetails(updatedList)

      // to filter price level and remove the selected ones in the option
      const flattenedNewList = updatedList.flat() // Flatten the nested arrays
      const filteredOptions = priceLevel.filter((option) => {
        // Check if any object in flattenedNewList has the same price_level_id
        return !flattenedNewList.some(
          (item) => item.price_level_id === option.value
        )
      })

      setFilteredPriceLevels(filteredOptions)
    } else {
      const { name, value } = e.target

      const newList = [...priceLevelDetails]
      newList[level_index][unit_index][name] = value

      if (name === "margin") {
        var margin = value !== "" ? value : 0
        var cost_price = newList[level_index][unit_index]["cost_price"]
        var percentage =
          (parseFloat(cost_price) * parseFloat(margin)) / 100 +
          parseFloat(cost_price)
        newList[level_index][unit_index]["margin"] = value
        newList[level_index][unit_index]["selling_price"] = percentage
        newList[level_index][unit_index]["wholesale_price"] = percentage
        newList[level_index][unit_index]["retail_price"] = percentage

        // VAT calculations
        var vatEx = parseFloat(percentage) / 1.12
        var vatComponent = parseFloat(percentage) - vatEx
        newList[level_index][unit_index]["vat_in"] = percentage
        newList[level_index][unit_index]["vat_ex"] = vatEx
        newList[level_index][unit_index]["vat_component"] = vatComponent
      } else if (name === "cost_price") {
        var margin = newList[level_index][unit_index]["margin"]
          ? newList[level_index][unit_index]["margin"]
          : 0
        var cost_price = value !== "" ? value : 0
        var percentage =
          (parseFloat(cost_price) * parseFloat(margin)) / 100 +
          parseFloat(cost_price)
        newList[level_index][unit_index]["cost_price"] = value
        newList[level_index][unit_index]["selling_price"] = percentage
        newList[level_index][unit_index]["wholesale_price"] = percentage
        newList[level_index][unit_index]["retail_price"] = percentage

        // VAT calculations
        var vatEx = parseFloat(percentage) / 1.12
        var vatComponent = parseFloat(percentage) - vatEx
        newList[level_index][unit_index]["vat_in"] = percentage
        newList[level_index][unit_index]["vat_ex"] = vatEx
        newList[level_index][unit_index]["vat_component"] = vatComponent
      }
      setPriceLevelDetails(newList)
    }
  }

  // FUNCTION TO SAVE ITEM PRICE
  async function handleSaveItemPrice() {
    setIsClicked(true)
    const response = await createItemPrice(itemDetails, priceLevelDetails)
    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      })
      handleCloseAddItemPriceModal()
      setItemDetails({})
      setItemsUnits([])
      // fetchItems()
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
    }
    setIsClicked(false)
  }

  async function fetchPriceLevel() {
    setPriceLevels([])
    const response = await getAllPriceLevels()
    if (response.data) {
      var price_levels = response.data.data.map((data) => {
        var info = {}
        info.var_name = "price_level_id"
        info.for = "price_level_id_value"
        info.label = data.name
        info.value = data.id
        return info
      })
      setPriceLevels(price_levels)
      setFilteredPriceLevels(price_levels)
    }
  }

  useEffect(() => {
    if (showAddItemModal) {
      var subcat = subCategories.filter((data) => {
        return data.category_id === itemDetails?.category_id
      })
      setFilteredSubCategories(subcat)
    }
  }, [itemDetails.category])

  useEffect(() => {
    if (state) {
      // FOR LOW ON STOCK CREATE PO TO SET ITEMS
      var initialOrders = state.purchased_items.map((item) => {
        var info = {}
        info.item_id = parseInt(item.item_id)
        info.qty = (
          parseFloat(item.max) - parseFloat(item.current_qty)
        ).toString()
        info.item_name = item.item_name
        info.current_qty = item.current_qty
        info.unit = item.item_unit_id
        info.unit_to_name = item.unit_to_name
        info.price = item.price || "0"
        info.amount = (parseFloat(info.qty) * parseFloat(info.price)).toString()
        // info.remarks = "";
        info.isReadOnly = true

        return info
      })

      setItems(initialOrders)
      // setBranchValue(state.branch_id_value);
      setBranchValue({
        name: "branch_id",
        label: state.branch_name,
        value: state.branch_id,
      })
      var _grandTotal = initialOrders
        .map((item) => parseFloat(item.amount))
        .reduce((a, b) => a + b, 0)
      // setNewPO({
      //   ...newPO,
      //   grand_total: _grandTotal,
      //   branch_id: state.branch_id,
      //   // delivery_address:
      //   //   "Tacloban City Ice Plant, 164 Justice Romualdez St. Tacloban City, Leyte",
      //   purchase_date: new Date().toLocaleDateString("en-CA"),
      //   delivery_date: new Date().toLocaleDateString("en-CA"),
      // });
      setNewPO((prev) => {
        return {
          ...prev,
          grand_total: _grandTotal,
          branch_id: state.branch_id,
          // delivery_address:
          //   "Tacloban City Ice Plant, 164 Justice Romualdez St. Tacloban City, Leyte",
          purchase_date: new Date().toLocaleDateString("en-CA"),
          delivery_date: new Date().toLocaleDateString("en-CA"),
        }
      })
    }
  }, [])
  useEffect(() => {
    var tempServiceFee = newPO.service_fee ? parseFloat(newPO.service_fee) : 0

    var tempDiscount = newPO.discount ? parseFloat(newPO.discount) : 0

    var _subtotal = items
      .map((item) => parseFloat(item.amount))
      .reduce((a, b) => a + b, 0)

    var _grandTotal = _subtotal + tempServiceFee - tempDiscount
    setNewPO((prev) => {
      return {
        ...prev,
        subtotal: _subtotal.toFixed(2),
        grand_total: _grandTotal.toFixed(2),
      }
    })
  }, [isChanged])

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input")
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault()
      })
    })
  }
  limitScroll()

  return (
    <div>
      <Toaster position="top-right" reverseOrder={false} />
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"PURCHASES"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              ADD PURCHASE ORDER
            </h1>
          </Col>
        </Row>

        {/* content */}
        <div className="edit-form">
          <Row className="mb-3">
            <Col xs={12} lg={4}>
              <span className="edit-label">
                Supplier Name <label className="badge-required">{` *`}</label>
              </span>
              <SearchBox
                showSearch
                value={newPO.supplier_id_value}
                placeholder={"Search Supplier..."}
                className="react-select-container w-100"
                dropdownClassName="z-large antdesign-custom-dropdown"
                style={antdesignSelectStyle}
                defaultActiveFirstOption={false}
                suffixIcon={null}
                filterOption={false}
                onSearch={handleSearchSupplier}
                onChange={(e) => handleSelectChange(e, "supplier_id")}
                notFoundContent={null}
                options={(suppliers || []).map((d) => ({
                  value: d.value,
                  label: d.label,
                }))}
              />
              {/* <Select
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Supplier..."
                value={suppliersValue}
                options={suppliers}
                onChange={(e) => handleSelectChange(e)}
              /> */}
              <InputError
                isValid={isError.supplierName}
                message={"Supplier Name is required"}
              />
              <div className="d-flex justify-content-end">
                <span className="edit-label" style={{ color: "#df1227" }}>
                  Supplier Not Found?{" "}
                  <a
                    onClick={handleAddSupplierClick}
                    className="add-supplier-label"
                  >
                    Add supplier
                  </a>
                </span>
              </div>
            </Col>
            <Col xs={12} lg={4} className="mt-4 mt-lg-0">
              <span className="edit-label">
                Purchase Date <label className="badge-required">{` *`}</label>
              </span>
              <Form.Control
                type="date"
                name="purchase_date"
                className="nc-modal-custom-text"
                value={newPO.purchase_date}
                onChange={(e) => handlePOChange(e)}
                // max={today}
              />
              <InputError
                isValid={isError.purchaseDate}
                message={"Purchase date is required"}
              />
              <div className="d-flex justify-content-end">
                <span
                  className="edit-label"
                  style={{ color: "white" }}
                >{` -`}</span>
              </div>
            </Col>
            <Col xs={12} lg={4} className="mt-4 mt-lg-0">
              <span className="edit-label">
                Delivery Date <label className="badge-required">{` *`}</label>
              </span>
              <Form.Control
                type="date"
                name="delivery_date"
                className="nc-modal-custom-input"
                defaultValue={newPO.delivery_date}
                onChange={(e) => handlePOChange(e)}
              />
              <InputError
                isValid={isError.deliveryDate}
                message={"delivery date is required"}
              />
              <div className="d-flex justify-content-end">
                <span
                  className="edit-label"
                  style={{ color: "white" }}
                >{` -`}</span>
              </div>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12} lg={6}>
              <span className="edit-label">Contact Name</span>
              <Form.Control
                type="text"
                name="contact_name"
                className="nc-modal-custom-input"
                value={newPO.contact_name}
                onChange={(e) => handlePOChange(e)}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-4 mt-lg-0">
              <span className="edit-label ">Contact No.</span>
              <Form.Control
                type="text"
                name="contact_no"
                className="nc-modal-custom-input"
                value={newPO.contact_no}
                onChange={(e) => handlePOChange(e)}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12} lg={4}>
              <span className="edit-label ">Branch</span>
              <label className="badge-required">{` *`}</label>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Branch..."
                // value={branchList.length > 0 ? branchList[0] : null}
                options={branchList}
                onChange={(e) => handleSelectChange(e)}
              />
              <InputError
                isValid={isError.branchId}
                message={"Branch is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-4 mt-lg-0">
              <span className="edit-label">Forwarder</span>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Forwarder..."
                value={forwardersValue}
                options={forwarders}
                onChange={(e) => handleSelectChange(e)}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-4 mt-lg-0">
              <span className="edit-label">Forwarder Contact No.</span>
              <Form.Control
                type="text"
                name="contact_person"
                className="nc-modal-custom-input"
                defaultValue={newPO.contact_person}
                onChange={(e) => handlePOChange(e)}
              />
              {/* <InputError
                isValid={isError.requisitioner}
                message={"requisitioner is required"}
              /> */}
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12} lg={6}>
              <span className="edit-label">
                Delivery Address{" "}
                <label className="badge-required">{` *`}</label>
              </span>
              <Form.Control
                type="text"
                name="delivery_address"
                className="nc-modal-custom-input"
                defaultValue={newPO.delivery_address}
                onChange={(e) => handlePOChange(e)}
              />
              <InputError
                isValid={isError.deliveryAddress}
                message={"delivery address is required"}
              />
            </Col>
            <Col xs={12} lg={6} className="mt-4 mt-lg-0">
              <span className="edit-label">
                Requested by <label className="badge-required">{` *`}</label>
              </span>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Employee..."
                value={newPO.requisitioner}
                options={employees}
                onChange={(e) => handleSelectChange(e, "requisitioner")}
              />
              <InputError
                isValid={isError.requisitioner}
                message={"requisitioner is required"}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <span className="edit-label mb-2">
                Purchased Items <label className="badge-required">{` *`}</label>
              </span>
              <div className="edit-purchased-items">
                {items.length === 0 ? (
                  <span>No Purchased Item Found!</span>
                ) : (
                  renderTable()
                )}
                <InputError
                  isValid={isError.itemsList}
                  message={"You must add at least 1 purchased item"}
                />
              </div>
              <div className="d-flex justify-content-end">
                <span className="edit-label" style={{ color: "#df1227" }}>
                  Item Not Found?{" "}
                  <a onClick={handleAddItem} className="add-supplier-label">
                    add item
                  </a>
                </span>
              </div>
            </Col>
          </Row>
          <Row className="pt-3 PO-add-item">
            <Col>
              <Button
                type="button"
                onClick={() => AddItem()}
                // disabled={branchValue.value === "" ? true : false}
              >
                Add Item
              </Button>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col>
              <span className="edit-label">
                Remarks
                <span className="edit-optional px-2">(Optional)</span>
              </span>
              <Form.Control
                as="textarea"
                name="remarks"
                className="nc-modal-custom-input"
                value={newPO.remarks}
                onChange={(e) => handlePOChange(e)}
              />
            </Col>
          </Row>

          <Row className="mt-4 mb-2">
            <Col>
              <span className="edit-label">File Attachment</span>
              <Dragger
                fileList={fileList}
                onRemove={handleRemove}
                beforeUpload={handleBeforeUpload}
                multiple={false}
                listType="picture"
                progress={{ showInfo: true }}
              >
                <img src={upload} className="cursor-pointer" />
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Dragger>
            </Col>
          </Row>

          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">Subtotal</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle">
                {numberFormat(newPO.subtotal)}
              </span>
            </Col>
          </Row>
          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">
                Delivery/Service Fee
              </span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3}>
              <Form.Control
                type="number"
                name="service_fee"
                min={0}
                step="0.01"
                className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                onChange={(e) => handlePOChange(e)}
              />
            </Col>
          </Row>

          <Row className="align-right pt-3">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray">Discount</span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle">PHP</span>
            </Col>
            <Col xs={3}>
              <Form.Control
                type="number"
                name="discount"
                min={0}
                step="0.01"
                className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                onChange={(e) => handlePOChange(e)}
              />
            </Col>
          </Row>

          <Row className="align-right py-5">
            <Col xs={8} className="text-end">
              <span className="edit-label color-gray grand-total-text">
                Grand Total
              </span>
            </Col>
            <Col xs={1} className="text-end">
              <span className="edit-label align-middle grand-total-text">
                PHP
              </span>
            </Col>
            <Col xs={3} className="text-end">
              <span className="edit-label align-middle grand-total-text">
                {"" + numberFormat(newPO.grand_total)}
              </span>
            </Col>
          </Row>

          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>

            {isSaveClicked ? (
              <div className="button-tertiary me-3 d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-tertiary me-3"
                onClick={() => savePO()}
              >
                Save
              </button>
            )}
            {isSubmitClicked ? (
              <div className="button-primary d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-primary"
                onClick={submitPO}
              >
                Submit
              </button>
            )}
          </div>
        </div>
      </div>
      <AddModal
        title="SUPPLIER"
        show={showAddSupplierModal}
        onHide={handleCloseAddSupplierModal}
        onSave={handleAddSupplier}
      >
        <div className="mt-3 edit-form">
          <Row className="nc-modal-custom-row mt-0">
            <Col>
              BIR NAME <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="bir_name"
                value={supplierDetails.bir_name}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col>
              TRADE NAME <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="trade_name"
                value={supplierDetails.trade_name}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              BIR-REGISTERED ADDRESS
              <Form.Control
                type="text"
                name="bir_address"
                value={supplierDetails.bir_address}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col>
              TRADE ADDRESS <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="trade_address"
                value={supplierDetails.trade_address}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              TIN NUMBER <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="tin"
                value={supplierDetails.tin}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col>
              BIR NUMBER
              <Form.Control
                type="text"
                name="bir_number"
                className="nc-modal-custom-input"
                required
              />
            </Col>
            <Col xl={3}>
              TERM (DAYS) <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="terms"
                value={supplierDetails.terms}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xl={4}>
              CONTACT PERSON <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="contact_person"
                value={supplierDetails.contact_person}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col xl={4}>
              PHONE NUMBER <label className="badge-required">{` *`}</label>
              <Form.Control
                type="text"
                name="phone_no"
                value={supplierDetails.phone_no}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col>
              PAYEE <label className="badge-required">{` *`}</label>
              <Form.Control
                type="email"
                name="payee"
                value={supplierDetails.payee}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              PRIMARY BANK NAME
              <Form.Control
                type="text"
                name="bank_primary"
                value={supplierDetails.bank_primary}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col>
              PRIMARY ACCOUNT NO.
              <Form.Control
                type="number"
                name="primary_account_no"
                className="nc-modal-custom-input hide-spinner numeric-input"
                required
              />
            </Col>
            <Col xl={5}>
              PRIMARY ACCOUNT NAME
              <Form.Control
                type="text"
                name="primary_account_name"
                className="nc-modal-custom-input"
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              ALTERNATE BANK NAME
              <Form.Control
                type="text"
                name="bank_alternate"
                value={supplierDetails.bank_alternate}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
            <Col>
              ALTERNATE ACCOUNT NO.
              <Form.Control
                type="number"
                name="alternate_account_no"
                className="nc-modal-custom-input"
                required
              />
            </Col>
            <Col xl={5}>
              ALTERNATE ACCOUNT NAME
              <Form.Control
                type="text"
                name="alternate_account_name"
                className="nc-modal-custom-input"
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xl={4}>
              COMPANY EMAIL <label className="badge-required">{` *`}</label>
              <Form.Control
                type="email"
                name="email"
                value={supplierDetails.email}
                className="nc-modal-custom-input"
                onChange={(e) =>
                  setSupplierDetails({
                    ...supplierDetails,
                    [e.target.name]: e.target.value,
                  })
                }
                required
              />
            </Col>
          </Row>
          <Row className="m-divider mt-3 mb-3"></Row>
          <Row className="nc-modal-custom-row">
            <Col>
              REQUIREMENTS
              <Form.Control
                type="file"
                multiple
                name="requirements"
                className="nc-modal-custom-input"
                required
              />
            </Col>
          </Row>
        </div>
      </AddModal>

      {/* ADD ITEM MODAL */}
      <AddModal
        title={`ITEM`}
        type="item"
        show={showAddItemModal}
        onHide={handleCloseAddItemModal}
        onSave={handleSaveItem}
        isClicked={isClicked}
      >
        <div className=" mt-3">
          <Row className="nc-modal-custom-row mt-0">
            <span className="custom-modal-body-title-employee mb-3">
              ITEM DESCRIPTION
            </span>
            <Col>
              ITEM NAME
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="name"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isErrorItem.name}
                message={"Item name is required"}
              />
            </Col>
            <Col>
              BRAND
              <Typeahead
                id="basic-typeahead-single"
                name="value"
                labelKey="value"
                allowNew
                className="nc-modal-custom-text"
                onChange={(e) => handleTypeaheadChange(e, "brand")}
                options={brand}
                placeholder="Select/type a brand..."
                selected={itemDetails.selected_brand}
              />
            </Col>
            <Col>
              MODEL
              <Form.Control
                type="text"
                name="model"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col>
              MATERIAL
              <Form.Control
                type="text"
                name="material"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col>
              COLOR
              <Form.Control
                type="text"
                name="color"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col>
              SIZE
              <Form.Control
                type="text"
                name="size"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-3">
            <span className="custom-modal-body-title-employee mb-3">
              ITEM DETAILS
            </span>
            <Col>
              BARCODE
              <Form.Control
                type="text"
                name="barcode"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col>
              INHOUSE BARCODE
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="inhouse_barcode"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isErrorItem.inhouse_barcode}
                message={"Inhouse barcode is required"}
              />
            </Col>
            <Col>
              SERIAL NUMBER
              <Form.Control
                type="text"
                name="serial_number"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col>
              TAG
              <Form.Control
                type="text"
                name="tag"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col>
              ITEM CODE
              <Form.Control
                type="text"
                name="tag"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col>
              SALES TYPE
              <span className="required"> * </span>
              <select
                name="sales_type"
                className="ms-0 nc-modal-custom-select nc-modal-custom-input-edit "
                onChange={(e) => handleAddChange(e)}
              >
                <option hidden selected className="nc-modal-custom-select">
                  Select
                </option>
                <option value="wholesale"> Wholesale </option>
                <option value="retail"> Retail </option>
                <option value="universal"> Both </option>
              </select>
              <InputError
                isValid={isErrorItem.sales_type}
                message={"Sales type is required"}
              />
            </Col>
          </Row>
          <hr />
          <Row className="nc-modal-custom-row mt-3">
            <span className="custom-modal-body-title-employee mb-3">
              ITEM CATEGORY
            </span>
            {itemDetails?.category?.map((data, index) => {
              return (
                <Col xs={3}>
                  {index === 0 ? "CATEGORY" : "SUB-CATEGORY"}
                  <Row className="align-middle">
                    <Col xs={10}>
                      <Select
                        name="subcategories"
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select..."
                        value={data}
                        options={
                          index === 0
                            ? categories
                            : itemDetails?.category_options[index]
                        }
                        // options={filteredSubCategories}
                        onChange={(e) =>
                          handleSelectDropdownChange(e, "add", index)
                        }
                      />
                      <InputError
                        isValid={isError.category}
                        message={"Category is required"}
                      />
                    </Col>
                    {index !== 0 && (
                      <Col xs={2}>
                        <img
                          src={trash}
                          alt="delete"
                          onClick={() => handleRemoveSubcategory(index, "add")}
                          className="cursor-pointer mt-2"
                        />
                      </Col>
                    )}
                  </Row>
                </Col>
              )
            })}
          </Row>
          <Row></Row>
        </div>
      </AddModal>
      {/* ADD CONVERSION MODAL */}
      <AddModal
        title={`UNIT OF MEASURE CONVERSION`}
        type="item"
        show={showAddConversionModal}
        onHide={handleCloseAddConversionModal}
        onSave={handleAddConversion}
        isClicked={isClicked}
      >
        <div className=" mt-3 ">
          <Row className="nc-modal-custom-row mb-0">
            <Col>UNIT OF MEASURE CONVERSION</Col>
          </Row>
          <Row className="nc-modal-custom-row mt-0">
            <div className="edit-purchased-items justify-content-center">
              <div className="not-found mt-0 ">
                {itemsUnits.length === 0 ? (
                  <span> No unit of measure conversion found! </span>
                ) : (
                  renderTableConversion()
                )}
              </div>
            </div>
          </Row>
        </div>
      </AddModal>
      <AddModal
        title={`ITEM PRICE`}
        type="item"
        show={showAddItemPriceModal}
        onHide={handleCloseAddItemPriceModal}
        onSave={handleSaveItemPrice}
        isClicked={isClicked}
      >
        <div className=" mt-3 ">
          <Row className="nc-modal-custom-row mt-3">
            <Col xs={6}>
              ITEM NAME
              <Form.Control
                type="text"
                name="name"
                value={itemDetails.name}
                className="nc-modal-custom-input"
                disabled
              />
            </Col>
          </Row>
          <hr />
          {priceLevelDetails?.map((data, key) => {
            return (
              <>
                <Row className="nc-modal-custom-row mt-3">
                  <Col xs={6}>
                    PRICE LEVEL
                    <Select
                      className="react-select-container"
                      classNamePrefix="react-select"
                      placeholder="Select item..."
                      value={data.price_level_id_value}
                      options={filteredPriceLevel}
                      onChange={(e) =>
                        handlePriceLevelChange(e, "price_level", key)
                      }
                      isDisabled={filteredPriceLevel.length > 0 ? false : true}
                    />
                  </Col>
                  <Col xs={4}></Col>
                  <Col xs={2} className="pt-3 PO-add-item">
                    <Button
                      type="button"
                      onClick={() => handleRemovePriceLevel(key)}
                    >
                      Delete
                    </Button>
                  </Col>
                </Row>
                {data?.map((item, index) => {
                  return (
                    <>
                      <Row key={index} className="nc-modal-custom-row mt-3">
                        <Col className="unit">{item.unit_from}</Col>
                        <Col>
                          COST
                          <Form.Control
                            type="number"
                            name="cost_price"
                            value={item.cost_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            disabled={
                              parseFloat(item.original_cost_price) === 0
                                ? false
                                : true
                            }
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                          />
                        </Col>
                        <Col>
                          MARGIN %
                          <Form.Control
                            type="number"
                            name="margin"
                            value={item.margin}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          SELLING PRICE
                          <Form.Control
                            type="number"
                            name="selling_price"
                            value={item.selling_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          WS PRICE
                          <Form.Control
                            type="number"
                            name="wholesale_price"
                            value={item.wholesale_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          RETAIL PRICE
                          <Form.Control
                            type="number"
                            name="retail_price"
                            value={item.retail_price}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                      </Row>
                      <Row key={index} className="nc-modal-custom-row mt-1">
                        <Col>
                          SPEC. PRICE 1
                          <Form.Control
                            type="number"
                            name="special_price_1"
                            value={item.special_price_1}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          SPEC. PRICE 2
                          <Form.Control
                            type="number"
                            name="special_price_2"
                            value={item.special_price_2}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          SPEC. PRICE 3
                          <Form.Control
                            type="number"
                            name="special_price_3"
                            value={item.special_price_3}
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            required
                          />
                        </Col>
                        <Col>
                          VAT IN
                          <Form.Control
                            type="text"
                            name="vat_in"
                            value={
                              item.vat_in ? numberFormat(item.vat_in) : "0"
                            }
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            disabled
                          />
                        </Col>
                        <Col>
                          VAT EX
                          <Form.Control
                            type="text"
                            name="vat_ex"
                            value={
                              item.vat_ex ? numberFormat(item.vat_ex) : "0"
                            }
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            disabled
                          />
                        </Col>
                        <Col>
                          VAT COMPONENT
                          <Form.Control
                            type="text"
                            name="vat_component"
                            value={
                              item.vat_component
                                ? numberFormat(item.vat_component)
                                : "0"
                            }
                            className="nc-modal-custom-input hide-spinner numeric-input"
                            onChange={(e) =>
                              handlePriceLevelChange(e, "item_unit", key, index)
                            }
                            disabled
                          />
                        </Col>
                      </Row>
                    </>
                  )
                })}
                <hr />
              </>
            )
          })}
          <Row className="pt-3 PO-add-item">
            <Button
              type="button"
              disabled={filteredPriceLevel.length > 0 ? false : true}
              onClick={() => handleAddPriceLevel()}
            >
              Add Price Level
            </Button>
          </Row>
        </div>
      </AddModal>

      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewFile}
        />
      </Modal>
      <Modal
        open={fileSizeExceeded}
        title={""}
        footer={null}
        onCancel={() => setFileSizeExceeded(false)}
      >
        File size must not exceed 5MB.
      </Modal>
      <FileExceedModal
        show={showFileExceedModal}
        onHide={() => setShowFileExceedModal(false)}
        size="2MB"
      />
      <Footer />
    </div>
  )
}
